export const globalEnvironment = {
  dialogOptions: {
    autoFocus: false,
    closeOnNavigation: true,
    disableClose: true,
    hasBackdrop: true,
    maxWidth: '95vw',
    restoreFocus: false,
  },
  fileUploadSizeLimit: 10240000,
  locale: 'en-IN',
  maxCharLimit: 125,
  messages: {
    error: 'Oops! Something went wrong, Please try again',
    sessionTimeOut: 'Session Expired! Please login again',
    gatewayTimeout:
      'Oops, Unable to fetch large data set at the moment, Please try with a lesser date range or attempt later.',
  },
  pageOptions: {
    pageSize: 15,
    pageSizeOptions: [15, 30, 60, 90, 100],
    showFirstLastButtons: false,
  },
  toast: {
    duration: {
      info: 5000,
      success: 3000,
      error: 5000,
    },
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
  },
  yearLimit: 1900,
  abhaVerificationRequired: false,
};
